<template>
  <span
    class="tag"
    :class="[
      color,
      { bordered: bordered },
      { disabled: isDisabled },
      { rounded: rounded },
      { fluid: fluid }
    ]"
    @click="$emit('click')"
  >
    {{ text }}
  </span>
</template>

<script>
export default {
  name: "VTag",
  props: {
    type: {
      type: String,
      default: "status"
    },
    bordered: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    fluid: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "gray"
    },
    text: {
      type: [String, Number],
      default: "text"
    }
  }
};
</script>

<style lang="scss" scoped>
.tag {
  padding: 10px 20px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 5px;
  white-space: nowrap;
  display: inline-block;
  &.disabled {
    opacity: 0.5;
  }
  &.fluid {
    width: 100%;
  }
  &.bordered {
    background: transparent !important;
  }
  &.rounded {
    border-radius: 30px;
    font-weight: 600;
  }
  &.green {
    background: $green-light;
    &.bordered {
      border: solid 1px $green;
      color: $green;
    }
  }
  &.orange {
    background: $orange-light;
    &.bordered {
      border: solid 1px $orange;
      color: $orange;
    }
  }
  &.red {
    background: $red-light;
    &.bordered {
      border: solid 1px $red;
      color: $red;
    }
  }
  &.blue {
    background: $blue-light;
    &.bordered {
      border: solid 1px $blue;
      color: $blue;
    }
  }
  &.gray {
    background: $gray-light;
    color: $gray-dark;
    &.bordered {
      border: solid 1px $gray-border;
    }
  }
}
</style>
